/* eslint-disable max-len */

import FiroQuestion from 'images/coin-pages/questions/firo.svg'

import {ICoinPageData} from '../types'

export const firoPage: ICoinPageData = {
  title: 'coin_371',
  description: 'coin_372',
  // description: 'coin_373',
  questionsBlock: {
    image: FiroQuestion,
    questions: [
      {
        title: 'coin_374',
        answer: 'coin_375',
      },
      {
        title: 'coin_376',
        answer: 'coin_377',
      },
      {
        title: 'coin_378',
        answer: 'coin_379',
      },
      {
        title: 'coin_380',
        answer: 'coin_381',
      },
    ],
  },
  whatIs: {
    text: [],
    paragraphs: [
      {
        title: 'coin_382',
        text: ['coin_385'],
      },
      {
        title: 'coin_383',
        text: ['coin_386', 'coin_387', 'coin_388', 'coin_389', 'coin_390'],
      },
      {
        title: 'coin_384',
        text: ['coin_391', 'coin_392', 'coin_393', 'coin_394'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/coinrabbit-firo-new-earning-opportunities/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/06/IMG_4563.png',
        imageAlt: 'Firo (FIRO) cryptocurrency review 5',
      },
      {
        link: 'https://coinrabbit.io/blog/crypto-lending-growing-market-emerges-opportunities/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2021/05/photo_2021-05-26_21-10-19.jpg',
        imageAlt: 'Firo (FIRO) cryptocurrency review 6',
      },
      {
        link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/08/integration-52CR_LQ.png',
        imageAlt: 'Firo (FIRO) cryptocurrency review 7',
      },
    ],
  },
}
